import React from 'react';
import NewspaperIcon from '@mui/icons-material/Newspaper';

const NoData = () => {
    return (
        <div className='container'>
            <div className='inner_container'>
                <div style={{margin:'20rem auto',textAlign: 'center', }}>
                   <div style={{width:'200px', height:'200px',margin:'0 auto', padding:'40px', textAlign:'center' ,borderRadius:'50%', backgroundColor:'#f8f8f8' }}>
                       <NewspaperIcon sx={{fontSize:'120px', color: '#ddd'}} />
                   </div>
                    <h1 style={{margin:'30px 0', color:'#ddd', fontSize:'38px', fontWeight:'500'}}>No results found</h1>
                    <p style={{whiteSpace: 'pre-line', lineHeight:'21px',color:" #ddd"}}>
                        {`금일 보도된 뉴스가 없습니다.`}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NoData;